import React from 'react'
import YnsIcon from '~/components/icons/YnsIcon'
import { useCoachChat } from './CoachChatContext'

/** Figma waiting-room avatar — MUI AccountCircle (~17px; h-4/w-4 = 16px) */
const WaitingRoomPersonIcon = () => {
  const { getDarkModeClasses } = useCoachChat()

  return (
    <YnsIcon
      name="waiting-room-user"
      className={`h-4 w-4 shrink-0 ${getDarkModeClasses('text-[#08467c]', 'text-blue-400')}`}
      aria-hidden
    />
  )
}

export default WaitingRoomPersonIcon
